import { TimeString, DateString } from '@hermes/booking-calendar'
import { BookingSlotsResponse, BookingSlotRaw, BookingSlot, AvailabilityDate } from '../types/booking'

export const convertBookingSlotRawToSlotType = (bookingSlot: BookingSlotRaw, dayKey?: DateString): BookingSlot => {
  const [datePart = '', timePart = ''] = bookingSlot.start.includes('T')
    ? bookingSlot.start.split('T')
    : ['', bookingSlot.start]

  return {
    id: bookingSlot.id,
    date: (dayKey || datePart) as DateString,
    time: timePart.split(':').slice(0, 2).join(':') as TimeString,
    provider: bookingSlot.provider,
    practice: bookingSlot.practice
  }
}

export const transformSpecialistBookingSlots = (bookingSlots: BookingSlotsResponse): Array<BookingSlot> => {
  const availability = bookingSlots?.availability
  const dayKeys = (Object.keys(availability) ?? []) as Array<AvailabilityDate>

  return dayKeys.reduce((prev, dayKey) => {
    const daySlotsRaw = availability[dayKey] as Array<BookingSlotRaw>
    const daySlots = daySlotsRaw.map((slot: BookingSlotRaw) => convertBookingSlotRawToSlotType(slot, dayKey))

    const daySlotsSorted = daySlots.sort((a, b) => +new Date(`${a.date} ${a.time}`) - +new Date(`${b.date} ${b.time}`))

    return [...prev, ...daySlotsSorted]
  }, [] as Array<BookingSlot>)
}
